<script>import SchemaField from "../../../components/form/SchemaField.svelte";
import {
  ChartConfigurationSchemaIds,
  ChartConfigurationTags
} from "./schemas/configuration.const.js";
import * as schemas from "./schemas/index.js";
import * as i18n from "./i18n/index.js";
import { usageId } from "../../../constants/usageid.js";
import { Locale } from "../../../i18n/translatable.js";
import { tlmdSchema } from "../../../schemas/index.js";
import { Operation } from "../../../schemas/schema.types.js";
import { getFormControlDefinitions, getFormTexts } from "../../../schemas/usage.js";
export let locale = Locale.en;
export let value;
export let name;
export let order = [];
const usage = usageId(
  ChartConfigurationSchemaIds.CHART_CONFIGURATION,
  ChartConfigurationTags.DEFAULT
);
const operation = Operation.UPDATE;
let tlmdObjectSchema = tlmdSchema(usage, operation);
let controls = getFormControlDefinitions(
  tlmdObjectSchema,
  operation
);
const formTexts = getFormTexts(tlmdObjectSchema, locale);
const fieldsOrder = order;
const story = "filled";
const disabled = false;
let errors = {
  visible: void 0,
  interval: void 0
};
const context = {};
</script>

<div class="configurator">
	<div class="caption">{formTexts.title.replaceAll('{name}', name)}</div>
	<form>
		{#each Object.values(controls) as control}
			<SchemaField
				on:changed
				on:state
				name={control.name}
				{story}
				{disabled}
				{errors}
				{value}
				{locale}
				{context}
				{control}
				formSchema={tlmdObjectSchema}
			/>
		{/each}
	</form>
</div>

<style>
	.configurator {
		margin: 1rem 0.5rem;
	}
	.caption {
		font-weight: 700;
		font-size: 18px;
		display: inline-block;
		margin-bottom: 1em;
	}
</style>
